import { render, staticRenderFns } from "./organizationsMain.vue?vue&type=template&id=0616fb9a&scoped=true&"
import script from "./organizationsMain.vue?vue&type=script&lang=js&"
export * from "./organizationsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0616fb9a",
  null
  
)

export default component.exports